import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { InternalLinkProps } from "../sitemap/plp-sitemap";
import { css } from "@emotion/react";
import { SwarovskiButton } from "../../../components/_shared-components/ui-elements/SwarovskiButton";
import React from "react";
import cn from "classnames";
import { SparePartsProductListingPageTranslation } from "@swo/storefront";
import { T } from "../../../components/T";

export const SparePartsFinderBottomNavigation: ReactTFC<{
  link: InternalLinkProps;
  centered?: boolean;
  translations: SparePartsProductListingPageTranslation;
}> = props => {
  return (
    <div
      className={cn({ centered: !!props.centered })}
      css={css`
        display: flex;
        justify-content: left;
        &.centered {
          justify-content: center;
        }
      `}
    >
      <SwarovskiButton variant={"outline"} as={"a"} link={props.link} isInternal={true}>
        <T>{props.translations["spare_parts_product_listing_page.back"]}</T>
      </SwarovskiButton>
    </div>
  );
};
